module.exports = __webpack_public_path__ + "static/media/8.d02440ca.jpg";